import { gsap } from 'gsap';
import { initLenis } from './util/lenis';
import { initStickyHeader } from './components/site-header';
import { initSiteMenu } from './components/site-menu';
import { initContentRevealScroll } from './components/reveal-content';
import { initUnicorn } from './components/unicorn';
import { initSliders } from './components/slider';
import { initFlickCards } from './components/flick-card';
import { initAccordions } from './components/accordion';
import { initTabs } from './components/tab';
import { initPricing } from './components/pricing';
import { initHowItWorks } from './components/how-it-works';
import { initNewsletterForms } from './components/newsletter';
import { initLightbox } from './components/lightbox';
import { initModalBasic } from './components/modal';
import { initEvents } from './components/events';
import { initConfirmation } from './components/confirmation';

const completeLoading = () => {
  initContentRevealScroll();

  document.documentElement.classList.remove('state--loading');
  gsap.to('.loader', {
    autoAlpha: 0,
    duration: 1,
    onComplete: function() {
      document.querySelector('.loader').remove();
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initEvents();

  document.fonts.ready.then(function() {
    initLenis();
    initStickyHeader();
    initSiteMenu();
    initSliders();
    initFlickCards();
    initAccordions();
    initTabs();
    initPricing();
    initHowItWorks();
    initNewsletterForms();
    initLightbox();
    initModalBasic();
    initConfirmation();

    let unicornScenes = document.querySelectorAll('[data-us-project]');
    if(unicornScenes.length > 0) {
      UnicornStudio.init()
      .then((scenes) => {
        completeLoading();
      })
      .catch((err) => {
        console.error(err);
        completeLoading();
      });
    } else {
      completeLoading();
    }
  });
});